import {
    Component,
    OnInit,
    Input,
    Output,
    ViewChild,
    EventEmitter
} from "@angular/core";
import { DatePipe } from "@angular/common";
import { ReportService } from "../../../../services/index";
@Component({
    selector: "poSwatchReport",
    templateUrl: "poSwatchReport.html"
})
export class PoSwatchReport implements OnInit {
    @Input("tabTitle") title: string;
    @Input("tabID") tabID: string;
    @Input() active = false;
    @Input() dataContext;
    @Output() tabUpdateEvent = new EventEmitter();
    order_no: any = "";
    loading = false;
    statustype = ["RECEIVED", "PENDING"];
    designType = [];
    data: any = {};
    detail: any = {};
    row = [];
    filter: any = {
        status: "PENDING",
        type: "",
        order_no: "",
        po_date: ""
    };
    gridOptions: any;
    columnDefs: any[];
    menu : any;
    isLoadMask: Promise<any>;
    loadingIndicator: boolean = true;
    columns = [];
    rowData: any[] = [];
    orderList: any = [];
    toggleCol = [];
    @ViewChild("tabContent") tabContent;
    @ViewChild("entryContainer") entryContainer;
    @ViewChild("listContainer") listContainer;
    constructor(private service: ReportService, private dp: DatePipe) { }
    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: "invoice_no",
        orderDir: "asc"
    };
    printConfig: any = {
        title: "Order Form Stock",
        columns: [],
        rows: []
    };

    ngOnInit(): void {
        if(this.menu.param == 'GangCore'){
            this.designType = ['CORE','GANG'];
            this.filter.type = "CORE";
          }else{
            this.designType = ['NEW','ALL'];
            this.filter.type = "ALL";
          }
        this.getColumns();
        this.toggleCol = Object.assign({}, this.columns);
    }

    getColumns() {
        this.columns = [];

        this.gridOptions = {
            columns: this.columns,
            loading: true,
            data: []
        };

        this.pageCallback({ offset: 0 });
    }
    applyFilter() {
        this.poBulkPending();
    }
    onCellClick(event) {
        this.filter.order_no = event.row.order_no;
        this.filter.po_date = event.row.po_date;

        this.poBulkPending();
    }
    poBulkPending() {
        this.loadingIndicator = true;
        let params = {
            filter: JSON.stringify(this.filter)
        };
        this.isLoadMask = this.service
            .poBulkPending(params)
            .then((res: any) => {
                if (res.success) {
                    this.loadingIndicator = false;
                    this.page.count = res.totCnt;
                    this.orderList = res.data;
                    this.gridOptions = {
                        cols: res.cols,
                        columns: res.columns,
                        data: res.data,
                        loading: false
                    };
                    this.filter.order_no = "";
                    this.filter.po_date = "";
                }
                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
            });
    }

    onbackbutton() {
        this.getColumns();
    }
    pageCallback(pageInfo: {
        count?: number;
        pageSize?: number;
        limit?: number;
        offset?: number;
    }) {
        this.page.offset = pageInfo.offset;
        this.poBulkPending();
    }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/POStatusReports/poSwatchReport/poSwatchReport.ts